import { useStore, useStoreMap } from 'effector-react'
import { useMainTaxipark } from '~/widgets/MainTaxipark'
import { $bookingCar } from '~/features/BookingCars/BookingCar/model'
import { driverModel } from '~/entities/Driver'
import { DriverStatus, rentalContractModel } from '~/entities/RentalContract'
import { DriverStatusEnum } from '~/shared/config/enums'
import { notificationModalOpen } from '~/shared/lib/notificationModal'
import { Button } from '~/shared/ui/Buttons'
import { TaxiparkWarning } from './TaxiparkWarning'
import { WorksWarning } from './WorksWarning'

type BookingButtonProps = {
  onClick: () => void
}

export function BookingButton({ onClick }: BookingButtonProps) {
  const rentalContract = useStore(rentalContractModel.$rentalContract)
  const rentalContractPending = useStore(
    rentalContractModel.getRentalContractFx.pending,
  )

  const mainTaxipark = useMainTaxipark()
  const bookingCar = useStore($bookingCar)
  const bookingCarTaxipark = bookingCar?.getTaxipark()

  const status = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getStatus(),
  )
  const driverIsLead = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getIsLead(),
  )

  const isRentalContractButtonShow =
    status === DriverStatusEnum.APPROVED ||
    status === DriverStatusEnum.FIRED ||
    driverIsLead

  const handleOnClick = async () => {
    if (rentalContract) {
      notificationModalOpen({
        description: 'Нельзя забронировать автомобиль с активным договором',
        variant: 'warning',
        buttonTitle: 'Понятно',
      })
    } else {
      onClick()
    }
  }

  if (status === DriverStatusEnum.WORKS) {
    return <WorksWarning />
  }

  if (mainTaxipark?.id !== bookingCarTaxipark?.getApiId()) {
    return (
      <TaxiparkWarning
        taxiparkName={bookingCarTaxipark?.getName()}
        taxiparkId={bookingCarTaxipark?.getApiId()}
      />
    )
  }

  return isRentalContractButtonShow ? (
    <Button
      variant='limeFlooded'
      size='large'
      fullWidth
      onClick={handleOnClick}
      loading={rentalContractPending}
    >
      Забронировать на 2 часа
    </Button>
  ) : (
    <DriverStatus />
  )
}
